import React from 'react';
import {
  ShopOutlined,
  DesktopOutlined,
  MoneyCollectOutlined,
  TagOutlined,
  PayCircleOutlined,
  SkinOutlined,
  TagsOutlined,
  FieldTimeOutlined,
  CloudOutlined,
  ClockCircleOutlined,
  SketchOutlined,
  AppstoreOutlined,
  BankOutlined,
} from '@ant-design/icons';
import { AccountBookOutlined } from '@drip/drip-design-icons';

export const MYCREATESTATUS = [
  {
    title: '不限',
    val: null,
  },
  {
    title: '有效',
    val: true,
  },
  {
    title: '无效',
    val: false,
  },
];

export const MYJOINSTATUS = [
  {
    title: '不限',
    val: '',
  },
  {
    title: '有效',
    val: true,
  },
  {
    title: '无效',
    val: false,
  },
];

export const cardStatusColor = [
  {
    key: '进行中',
    value: 'ING',
    id: 2,
  },
  {
    key: '未开始',
    value: 'WILL',
    id: 1,
  },
  {
    key: '已结束',
    value: 'ED',
    id: 3,
  },
];

export const myJoinCardStatusColor = [
  {
    key: '报名中',
    value: 'ING',
    id: 2,
  },
  {
    key: '未开始',
    value: 'WILL',
    id: 1,
  },
  {
    key: '已结束',
    value: 'ED',
    id: 3,
  },
];

export function renderCardStatusColor(status) {
  for (let i = 0; i < cardStatusColor.length; i++) {
    if (cardStatusColor[i].id === status) {
      return `${cardStatusColor[i].value} status`;
    }
  }
}

export function renderStatus(status) {
  for (let i = 0; i < cardStatusColor.length; i++) {
    if (cardStatusColor[i].id === status) {
      return cardStatusColor[i].key;
    }
  }
}

export function renderMyJoinStatus(status) {
  for (let i = 0; i < myJoinCardStatusColor.length; i++) {
    if (myJoinCardStatusColor[i].id === status) {
      return myJoinCardStatusColor[i].key;
    }
  }
}

export function renderActivityType(type) {
  for (let i = 0; i < ACTIVITY_TYPE.length; i++) {
    if (ACTIVITY_TYPE[i].value === type) {
      return { name: ACTIVITY_TYPE[i].name, text: ACTIVITY_TYPE[i].text };
    }
  }
  return {
    name: '',
    text: '',
  };
}

export function renderNiXiangActivityType(type) {
  let ACTIVITY_TYPE_COPY = ACTIVITY_TYPE.slice(0, -1);
  for (let i = 0; i < ACTIVITY_TYPE_COPY.length; i++) {
    if (ACTIVITY_TYPE_COPY[i].value === type) {
      return { name: ACTIVITY_TYPE_COPY[i].name, text: ACTIVITY_TYPE_COPY[i].text };
    }
  }
  return {
    name: '',
    text: '',
  };
}

export const ACTIVITY_TYPE = [
  { name: '跨店铺', value: 105, text: '跨店铺', icons: <ShopOutlined style={{ fontSize: '32px' }} /> },
  { name: '平台促销', value: 107, text: '平台促销', icons: <DesktopOutlined style={{ fontSize: '32px' }} /> },
  // { name: '自营总价促销', value: 109, text: '由于促销系统即将下线相关操作页面，自营总价促销类型活动将于1月7日下线。回归时间请关注系统公告。',icon:'bars' },    // 下架 2021.1.7
  { name: '优惠券', value: 108, text: '优惠券', icons: <MoneyCollectOutlined style={{ fontSize: '32px' }} /> },
  { name: '商品打标', value: 103, text: '打标', icons: <TagOutlined style={{ fontSize: '32px' }} /> },
  { name: '膨胀金', value: 111, text: '膨胀金', icons: <PayCircleOutlined style={{ fontSize: '32px' }} /> },
  { name: '单品促销', value: 104, text: '单品促销', icons: <SkinOutlined style={{ fontSize: '32px' }} /> },
  { name: '折扣促销', value: 110, text: '折扣促销', icons: <TagsOutlined style={{ fontSize: '32px' }} /> },
  { name: '自营总价', value: 109, text: '自营总价', icons: <TagsOutlined style={{ fontSize: '32px' }} /> },
  { name: '限时限量', value: 112, text: '限时限量', icons: <FieldTimeOutlined style={{ fontSize: '32px' }} /> },
  { name: '站外促销', value: 113, text: '站外促销', icons: <CloudOutlined style={{ fontSize: '32px' }} /> },
  { name: '平台预售', value: 114, text: '平台预售', icons: <ClockCircleOutlined style={{ fontSize: '32px' }} /> },
  { name: '跨店满减', value: 115, text: '跨店满减', icons: <SketchOutlined style={{ fontSize: '32px' }} /> },
  { name: '礼金促销', value: 117, text: '礼金促销', icons: <MoneyCollectOutlined style={{ fontSize: '32px' }} /> },
  { name: '总价促销', value: 119, text: '总价促销', icons: <MoneyCollectOutlined style={{ fontSize: '32px' }} /> },
  { name: '官方立减', value: 118, text: '官方立减', icons: <BankOutlined style={{ fontSize: '32px' }} /> },
  { name: '品牌购物卡', value: 120, text: '品牌购物卡', icons: <TagOutlined style={{ fontSize: '32px' }} /> },
  { name: '时尚购物卡', value: 121, text: '时尚购物卡', icons: <TagsOutlined style={{ fontSize: '32px' }} /> },
];

export const STATEGY_ACTIVITY_TYPE = [
  { name: '单品促销', value: 104, text: '单品促销', icons: <SkinOutlined style={{ fontSize: '32px' }} /> },
  { name: '折扣促销', value: 110, text: '折扣促销', icons: <TagsOutlined style={{ fontSize: '32px' }} /> },
];
export const ACTIVITY_TYPE_RENDER = [
  { name: '跨店铺', value: 105, text: '跨店铺', icons: <ShopOutlined style={{ fontSize: '32px' }} /> },
  { name: '平台促销', value: 107, text: '平台促销', icons: <DesktopOutlined style={{ fontSize: '32px' }} /> },
  // { name: '自营总价促销', value: 109, text: '由于促销系统即将下线相关操作页面，自营总价促销类型活动将于1月7日下线。回归时间请关注系统公告。',icon:'bars' },    // 下架 2021.1.7
  { name: '优惠券', value: 108, text: '优惠券', icons: <MoneyCollectOutlined style={{ fontSize: '32px' }} /> },
  { name: '商品打标', value: 103, text: '打标', icons: <TagOutlined style={{ fontSize: '32px' }} /> },
  { name: '膨胀金', value: 111, text: '膨胀金', icons: <PayCircleOutlined style={{ fontSize: '32px' }} /> },
  { name: '单品促销', value: 104, text: '单品促销', icons: <SkinOutlined style={{ fontSize: '32px' }} /> },
  { name: '折扣促销', value: 110, text: '折扣促销', icons: <TagsOutlined style={{ fontSize: '32px' }} /> },
  { name: '限时限量', value: 112, text: '限时限量', icons: <FieldTimeOutlined style={{ fontSize: '32px' }} /> },
  { name: '站外促销', value: 113, text: '站外促销', icons: <CloudOutlined style={{ fontSize: '32px' }} /> },
  { name: '平台预售', value: 114, text: '平台预售', icons: <ClockCircleOutlined style={{ fontSize: '32px' }} /> },
  { name: '跨店满减', value: 115, text: '跨店满减', icons: <SketchOutlined style={{ fontSize: '32px' }} /> },
  { name: '礼金促销', value: 117, text: '礼金促销', icons: <AccountBookOutlined style={{ fontSize: '32px' }} /> },
  { name: '总价促销', value: 119, text: '总价促销', icons: <MoneyCollectOutlined style={{ fontSize: '32px' }} /> },
  { name: '官方立减', value: 118, text: '官方立减', icons: <BankOutlined style={{ fontSize: '32px' }} /> },
  { name: '品牌购物卡', value: 120, text: '品牌购物卡', icons: <TagOutlined style={{ fontSize: '32px' }} /> },
  { name: '更多类型', value: -1, text: '更多类型', icons: <AppstoreOutlined style={{ fontSize: '32px' }} /> },
];

export function findZongcuIcon(code) {
  for (let i = 0; i < ACTIVITY_TYPE_RENDER.length; i++) {
    if (ACTIVITY_TYPE_RENDER[i].value === code) {
      return ACTIVITY_TYPE_RENDER[i];
    }
  }
  return {
    name: '',
    text: '',
    icons: null,
  };
}

/* 活动列表-筛选器-报名状态字段枚举 */
export const JOINSTATUS = {
  ALL: {
    value: null, //前端组件自身交互用到的值
    name: '全部',
  },
  NOAPPLY: {
    value: 0,
    name: '待报名',
  },
  HASAPPLY: {
    value: 1,
    name: '已报名',
  },
};

/* 活动列表-筛选器-报名状态字段枚举 */
export const CREATESTATUS = {
  ALL: {
    value: null, //前端组件自身交互用到的值
    name: '全部',
  },
  NOAPPLY: {
    value: true,
    name: '待发布',
  },
};
